const actions = {
  START_FETCH_MESSAGES: 'contact-form/START_FETCH_MESSAGES',
  END_FETCH_MESSAGES: 'contact-form/END_FETCH_MESSAGES',
  START_DELETING_MESSAGES: 'contact-form/START_DELETING_MESSAGES',
  END_DELETING_MESSAGES: 'contact-form/END_DELETING_MESSAGES',
  SET_MESSAGES: 'contact-form/SET_MESSAGES'
};

export default actions;
